import { useNavigate } from 'react-router-dom';

interface DashboardCardProps {
  title: string;
  value: string | number;
  subtitle?: string;
  percent?: string | undefined | null;
  percentColor?: string;
  img: string;
  to: string | undefined;
}
const DashboardCard: React.FC<DashboardCardProps> = ({
  title,
  value,
  subtitle,
  percent,
  percentColor,
  img,
  to,
}) => {
  const navigate = useNavigate();
  return (
    <div
      key={title}
      className={`bg-white rounded-tl-[26px] rounded-bl-[26px] flex items-center justify-between overflow-hidden shadow-1 ${to ? 'cursor-pointer' : ''}`}
      onClick={() => {
        if (to) {
          navigate(to);
        }
      }}
    >
      <div className="p-6">
        <h3 className="text-black text-sm mb-4">{title}</h3>
        <h2 className="text-[17px] text-black mb-2">{value}</h2>
        <p className="text-xs text-gray-100">
          {subtitle}
          <span className={`ml-1 text-sm font-medium ${percentColor}`}>
            {percent ? (percent || 0) + `%` : null}
          </span>
        </p>
      </div>
      <img className="h-full -mr-0.5" src={img} alt={title} />
    </div>
  );
};

export default DashboardCard;
